"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const HiddenRadio = _styledComponents.default.input.attrs({
  type: 'radio'
}).withConfig({
  displayName: "HiddenRadio"
})(["", ""], (0, _polished.hideVisually)());

const Label = _styledComponents.default.label.withConfig({
  displayName: "Label"
})(["cursor:pointer;display:inline-flex;align-items:center;> span{margin-left:0.33rem;font-size:1rem;}"]);

const Icon = _styledComponents.default.svg.withConfig({
  displayName: "Icon"
})(["display:block;"]);

const StyledRadio = _styledComponents.default.div.withConfig({
  displayName: "StyledRadio"
})(["display:inline-block;position:relative;width:16px;height:16px;border:1px solid ", ";background:", ";border-radius:100%;transition:all ", ";&::after{opacity:0;position:absolute;top:0;left:0;width:100%;height:100%;z-index:-1;content:\"\";border-radius:100%;transition:all ", ";}", ":hover &::after{opacity:1;}", "{visibility:", "}"], ({
  theme
}) => theme.palette.primary[0], ({
  theme,
  checked
}) => checked ? theme.palette.primary[0] : 'white', ({
  theme
}) => theme.anim.dur, ({
  theme
}) => theme.anim.dur, Label, Icon, props => props.checked ? 'visible' : 'hidden');

const RadioContainer = _styledComponents.default.div.withConfig({
  displayName: "RadioContainer"
})(["display:inline-block;height:18px;"]);

const Radio = (_ref) => {
  let className = _ref.className,
      checked = _ref.checked,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["className", "checked", "label"]);

  return /*#__PURE__*/_react.default.createElement(Label, null, /*#__PURE__*/_react.default.createElement(RadioContainer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(HiddenRadio, _extends({
    checked: checked
  }, props)), /*#__PURE__*/_react.default.createElement(StyledRadio, {
    checked: checked
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    width: "16",
    height: "16"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "2",
    fill: "white"
  })))), /*#__PURE__*/_react.default.createElement("span", null, label));
};

Radio.propTypes = {
  className: _propTypes.default.string,
  checked: _propTypes.default.bool.isRequired,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired
};
Radio.defaultProps = {
  className: '',
  label: ''
};
var _default = Radio;
exports.default = _default;